export default __webpack_public_path__ + "static/media/Bulb.20617cd9.png";